import { InjectionToken } from "@angular/core";

export const PORTAL_ANY_AUTHORIZING_ROLES_TOKEN = new InjectionToken<string[]>("PORTAL_ANY_AUTHORIZING_ROLES_TOKEN");
